let _ = t => t,
  _t,
  _t2;
import { CALYPSO, CALYPSO_LIGHT, CALYPSO_MEDIUM, OLAF } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'foundations-theming/utils';
import { breakpoint } from 'pricing-pages-ui-components/constants/Breakpoints';
import { jsx as _jsx } from "react/jsx-runtime";
const SelectorButtonWrapper = styled.div.withConfig({
  displayName: "MobileProductLevelSelectorButtons__SelectorButtonWrapper",
  componentId: "sc-9ajpbn-0"
})(["display:flex;width:94%;margin:0 auto;", ""], breakpoint.phoneLarge(_t || (_t = _`
    flex-direction: column;
  `)));
const SelectorButton = styled.button.withConfig({
  displayName: "MobileProductLevelSelectorButtons__SelectorButton",
  componentId: "sc-9ajpbn-1"
})(["font-size:0.75rem;padding:calc(1rem + 1px) 2rem;background:", ";flex-grow:1;flex-basis:33%;border:1px solid ", ";transition:background-color 0.3s;&:first-child{margin-right:-1px;border-radius:3px 0 0 3px;}&:last-child{margin-left:-1px;border-radius:0 3px 3px 0;}&:hover{background-color:", ";}&.active{font-weight:500;border-width:2px;border-color:", ";background-color:", ";}", ""], OLAF, CALYPSO_MEDIUM, CALYPSO_LIGHT, CALYPSO, CALYPSO_LIGHT, breakpoint.phoneLarge(_t2 || (_t2 = _`
    &:first-child {
      margin-bottom: -1px;
      margin-right: 0;
      border-radius: 3px 3px 0 0;
    }
    &:last-child {
      margin-top: -1px;
      margin-left: 0;
      border-radius: 0 0 3px 3px;
    }
  `)));
const MobileSelectorButton = ({
  productLevel,
  onClick,
  active
}) => {
  return /*#__PURE__*/_jsx(SelectorButton, {
    onClick: onClick,
    className: active ? 'active' : '',
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `productLevel.${productLevel}`
    })
  });
};
const MobileProductLevelSelectorButtons = ({
  productLevels,
  onClick,
  selectedProductLevel
}) => {
  return /*#__PURE__*/_jsx(SelectorButtonWrapper, {
    children: productLevels.map(productLevel => /*#__PURE__*/_jsx(MobileSelectorButton, {
      productLevel: productLevel,
      onClick: () => onClick(productLevel),
      active: selectedProductLevel === productLevel
    }, productLevel))
  });
};
export default MobileProductLevelSelectorButtons;